import { defineComponent as _defineComponent } from 'vue'
import { Modal } from '@/ui/components/Modal';
  import { Button } from '@/ui/components/Button';
  import { START_COURSE_MODAL_WIDTH } from '@/ui/components/modals/constants';
  import { PageSubtitle } from '@/ui/components/PageSubtitle';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'StartCourseModal',
  props: {
    active: { type: Boolean },
    title: { type: String, required: true },
    description: { type: String, required: false, default: '' },
  },
  emits: ['close', 'confirm'],
  setup(__props) {

  

  

return { __sfc: true,Modal, Button, START_COURSE_MODAL_WIDTH, PageSubtitle }
}

})